import React from 'react';

import { EXTERNAL_LINKS } from '../../constants/socialLinks';
import FacebookIcon from '../icons/FacebookIcon';
import TwitterIcon from '../icons/TwitterIcon';
import InstagramIcon from '../icons/InstagramIcon';
import SnapchatIcon from '../icons/SnapchatIcon';
import YoutubeIcon from '../icons/YoutubeIcon';
import TiktokIcon from '../icons/TiktokIcon';
import PatreonIcon from '../icons/PatreonIcon';
import BlueskyIcon from '../icons/Bluesky';


const getIcon = {
  facebook: <FacebookIcon />,
  twitter: <TwitterIcon />,
  instagram: <InstagramIcon />,
  snapchat: <SnapchatIcon />,
  youtube: <YoutubeIcon />,
  tiktok: <TiktokIcon />,
  patreon: <PatreonIcon />,
  bluesky: <BlueskyIcon />,
};

function SocialLinks() {
  return (
    <div className="social-links">
      {EXTERNAL_LINKS.map((link) => (
        <a
          key={link.id}
          className="social-links__icon"
          href={link.href}
          rel="noopener noreferrer"
          target="_blank"
          title={link.title}
        >
          {getIcon[link.icon]}
        </a>
      ))}
    </div>
  );
}

export default SocialLinks;
